import styled from "styled-components";
import { LuPencilLine } from "react-icons/lu";

const Card = styled.section`
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
`;

const Header = styled.header`
    height: 48px;
    background-color: #263B4B;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
`;

const Title = styled.h2`
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: #FFFFFF;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const EditBtn = styled.button`
    all: unset;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.12);
    transition: background-color 0.2s ease, transform 0.2s ease;

    & svg {
        width: 15px;
        height: 15px;
        color: #FFFFFF;
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.25);
        transform: scale(1.08);
    }

    &:focus-visible {
        outline: 2px solid #FFFFFF;
        outline-offset: 2px;
    }
`;

const Body = styled.div`
    box-sizing: border-box;
    padding: 14px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 10px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const InfoCard = ({ title, onEdit, showEdit, children, grid = true }) => {
    return (
        <Card>
            <Header>
                <Title>{title}</Title>
                {showEdit && onEdit && (
                    <EditBtn type="button" onClick={onEdit} title="Editar" aria-label="Editar">
                        <LuPencilLine />
                    </EditBtn>
                )}
            </Header>
            <Body>
                {grid ? <Grid>{children}</Grid> : children}
            </Body>
        </Card>
    )
}

export default InfoCard;
